import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: {
			minHeight: '42px',
		},
		indicator: ({ theme }: { theme: Theme }) => ({
			height: '3px',
			'&::after': {
				content: '""',
				width: '14px',
				height: '10px',
				background: theme.palette.primary.main,
				position: 'absolute',
				left: '50%',
				marginLeft: '-7px',
				bottom: '-4px',
				borderRadius: '100%',
			},
		}),
	},
};
